import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
const COLOR = {
    on: 'var(--color-sage)',
    live: 'var(--color-sage)',
    watch: 'var(--color-accent)',
    warning: 'var(--color-accent)',
    off: 'var(--color-rose)',
    critical: 'var(--color-rose)',
    info: 'var(--color-steel)',
    idle: 'var(--color-ink-muted)',
};
const DEFAULT_LABEL = {
    on: 'On track',
    live: 'Live',
    watch: 'Watch',
    warning: 'Warning',
    off: 'Off track',
    critical: 'Critical',
    info: 'Info',
    idle: 'Idle',
};
export function Status({ kind, label, className, }) {
    const color = COLOR[kind];
    const text = label ?? DEFAULT_LABEL[kind];
    return (_jsxs("span", { className: cn('inline-flex items-center gap-1.5 font-mono text-[11px] tracking-[0.04em]', className), style: { color }, children: [_jsx("span", { "aria-hidden": true, className: "inline-block size-[7px] rounded-full", style: { background: color } }), text] }));
}
